(function () {
  /* Add more entries here as the press list grows (10ish planned) - the strip
     doesn't need any other change to accommodate more photos. Fill in "link"
     once the article URLs are available; empty link = card renders as a
     non-clickable div instead of an anchor. */
  var PHOTOS = [
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Gizmodo.png?v=1787194157", name: "Gizmodo", position: "center", link: "https://youtu.be/5Q4mf3B1g4k?si=1aB1WwNVqJO_eMZF" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Le_Parisien.png?v=1787194156", name: "Le Parisien", position: "center 65%", link: "https://www.leparisien.fr/high-tech/ces-de-las-vegas-ces-innovations-qui-facilitent-votre-vie-au-bureau-14-01-2026-S3Y77QMDKFF4RBGV26PBWEI44Y.php" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Frandroid.png?v=1787215253", name: "Frandroid", position: "center 35%", link: "https://www.frandroid.com/produits-android/accessoires-objets-connectes/2848915_votre-voix-amplifiee-par-lia-un-francais-de-shenzhen-defie-plaud-et-le-projet-openai-jony-ive" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Newspicks.png?v=1787194155", name: "NewsPicks", position: "60% center", link: "https://newspicks.com/news/17036543/?ref=pickstream_2025" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Gizmart.png?v=1787194157", name: "Gizmart", position: "70% center", link: "https://www.gizmodo.jp/article/oxtak-money-penny-start/" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Lifehacker.png?v=1787194155", name: "LifeHacker", position: "center", link: "https://www.lifehacker.jp/article/2608-costorypo-oxtak-lh-edditorialreview-1175003493/" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/MetropolisWeb.png?v=1787215253", name: "Metropolis", position: "15% center", link: "https://www.metropolisweb.it/2026/01/13/las-vegas-vetrina-la-tecnologia-domani/" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Business_Insider.png?v=1787194154", name: "Business Insider", position: "55% center", link: "https://www.businessinsider.jp/article/2607-gizmart-oxtak-ai-recorder-ceo-interview/" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Frandroid_2.png?v=1787296468", name: "Frandroid", position: "center", link: "https://www.frandroid.com/produits-android/accessoires-objets-connectes/2928199_ce-boitier-ia-compatible-chatgpt-et-claude-enregistre-et-resume-vos-reunions" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Unlimit-Tech.png?v=1787215253", name: "Unlimit-Tech", position: "center 75%", link: "https://www.unlimit-tech.com/2026/01/oxtak-%d8%aa%d9%83%d8%b4%d9%81-%d8%b9%d9%86-%d8%ac%d9%87%d8%a7%d8%b2-moneypenny-%d9%84%d8%aa%d8%b3%d8%ac%d9%8a%d9%84-%d8%a7%d9%84%d8%b5%d9%88%d8%aa-%d8%a8%d8%a7%d9%84%d8%b0%d9%83%d8%a7%d8%a1-%d8%a7/" },
    { src: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/Notebookcheck.png?v=1787295233", name: "NotebookCheck", position: "55% center", link: "https://www.notebookcheck.net/Oxtak-unveils-Moneypenny-An-AI-powered-voice-recorder-with-meeting-summaries-and-translation-services.1196189.0.html" }
  ];

  // constant visual speed (px/s) regardless of how many photos end up in the list
  var PX_PER_SECOND = 45;
  // how much wider than the viewport each half of the track must be - a track
  // with only 2 copies loops seamlessly only while the viewport is narrower
  // than one copy; past that (large monitors), the seam becomes visible.
  // Repeating the list enough times per half fixes it at any screen size.
  var VIEWPORT_BUFFER = 1.15;

  var track = document.getElementById('oxpsTrack');
  var viewport = track ? track.parentElement : null;
  if (!track || !viewport) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cardHTML(p) {
    var inner =
      '<img src="' + p.src + '" alt="' + p.name + '" style="object-position:' + p.position + '" loading="lazy">' +
      '<span class="oxps-cap">' + p.name + '</span>';
    if (p.link) {
      return '<a class="oxps-item" href="' + p.link + '" target="_blank" rel="noopener noreferrer">' + inner + '</a>';
    }
    return '<div class="oxps-item">' + inner + '</div>';
  }

  if (reduceMotion) {
    // static, single copy, wraps normally - no loop, no motion at all
    track.className = 'oxps-track oxps-static';
    track.innerHTML = PHOTOS.map(cardHTML).join('');
    return;
  }

  var oneListHTML = PHOTOS.map(cardHTML).join('');

  function build(copiesPerHalf) {
    var half = '';
    for (var i = 0; i < copiesPerHalf; i++) half += oneListHTML;
    // two EQUAL halves, however many copies each holds, so -50% -> 0% always
    // lands exactly on the seam between them, regardless of copy count
    track.innerHTML = half + half;
  }

  function tune() {
    build(1);
    var oneListWidth = track.scrollWidth / 2;
    var neededCopies = Math.max(1, Math.ceil((viewport.clientWidth * VIEWPORT_BUFFER) / oneListWidth));
    if (neededCopies > 1) build(neededCopies);

    var halfWidth = track.scrollWidth / 2;
    track.style.animationDuration = (halfWidth / PX_PER_SECOND) + 's';
  }

  track.className = 'oxps-track';
  requestAnimationFrame(function () {
    tune();
    track.classList.add('oxps-animating');
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(tune, 150);
  });
})();
